import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { getToken, updateToken, store } from "@/store";
import { isJwtExpired } from 'jwt-check-expiration';
import { trackMatomoPageView } from "@/utils/matomo";
import { setPageDocumentTitle } from "@/utils/page-title";

import { administracaoRotas } from "./administracao.rotas";
import { atosPessoalRotas } from "./atos-pessoal.rotas";
import { avisosRotas } from "./avisos.rotas";
import { contratacaoRotas } from "./contratacao.rotas";
import { entregasRotas } from "./entregas.rotas";
import { eventosRotas } from "./eventos.rotas";
import { geralRotas } from "./geral.rotas";
import { internoRotas } from "./interno.rotas";
import { licitacoesRotas } from "./licitacoes.rotas";
import { novoUsuarioRotas } from "./novo-usuario-rotas";
import { ouvidoriaRotas } from "./ouvidoria.rotas";
import { processoEletronicoRotas } from "./processo-eletronico.rotas";
import { publicoRotas } from "./publico.rotas";
import { questionariosRotas } from "./questionarios.rotas";
import { relatoriosRotas } from "./relatorios.rotas";
import { serigyRotas } from "./serigy.rotas";

Vue.use(VueRouter);

const rotasProtegidas = [
  ...administracaoRotas,
  ...atosPessoalRotas,
  ...avisosRotas,
  ...contratacaoRotas,
  ...entregasRotas,
  ...eventosRotas,
  ...geralRotas,
  ...internoRotas,
  ...licitacoesRotas,
  ...novoUsuarioRotas,
  ...ouvidoriaRotas,
  ...processoEletronicoRotas,
  ...questionariosRotas,
  ...relatoriosRotas,
  ...serigyRotas,

].map((x: any) => {
  const rota = {
    ...x,
    meta: { ...(x.meta || {}), requiresAuth: true }
  }
  if (rota.children) {
    rota.children = rota.children.map(child => ({
      ...child,
      meta: { ...(child.meta || {}), requiresAuth: true }
    }))
  }
  return rota
})

const routes: Array<RouteConfig> = [
  ...rotasProtegidas,
  ...publicoRotas,
];

const router = new VueRouter({
  mode: "history",
  //base: "/portal-do-tce",
  routes,
});

getToken()
router.beforeEach((to, from, next) => {
  if ((store.token && isJwtExpired(store.token))) {
    updateToken(false, '', '')
    next({
      path: '/'
    })
  }
  //precisa de autenticacao e não tem
  else if (to.meta?.requiresAuth && (store.token === false)) {
    // console.log("from", from)
    // console.log("to", to)
    // console.log("store.token", store.token)
    next({
      path: '/'
    })
  }
  //não precisa de autenticacao e tem
  else if (!to.meta?.requiresAuth && store.token !== false) {
    //limpar store e localStorage
    updateToken(false, '', '')
    next()
  }
  else {
    next()
  }
})

router.afterEach((to) => {
  setPageDocumentTitle(to);
  trackMatomoPageView(to);
})

export default router;
